/*                                                                                                           
        CCCCCCCCCCCCC                                                                                                  
     CCC::::::::::::C                                                                                                  
   CC:::::::::::::::C                                                                                                  
  C:::::CCCCCCCC::::C                                                                                                  
 C:::::C       CCCCCC  aaaaaaaaaaaaa      mmmmmmm    mmmmmmm       eeeeeeeeeeee    rrrrr   rrrrrrrrr   aaaaaaaaaaaaa   
C:::::C                a::::::::::::a   mm:::::::m  m:::::::mm   ee::::::::::::ee  r::::rrr:::::::::r  a::::::::::::a  
C:::::C                aaaaaaaaa:::::a m::::::::::mm::::::::::m e::::::eeeee:::::eer:::::::::::::::::r aaaaaaaaa:::::a 
C:::::C                         a::::a m::::::::::::::::::::::me::::::e     e:::::err::::::rrrrr::::::r         a::::a 
C:::::C                  aaaaaaa:::::a m:::::mmm::::::mmm:::::me:::::::eeeee::::::e r:::::r     r:::::r  aaaaaaa:::::a 
C:::::C                aa::::::::::::a m::::m   m::::m   m::::me:::::::::::::::::e  r:::::r     rrrrrrraa::::::::::::a 
C:::::C               a::::aaaa::::::a m::::m   m::::m   m::::me::::::eeeeeeeeeee   r:::::r           a::::aaaa::::::a 
 C:::::C       CCCCCCa::::a    a:::::a m::::m   m::::m   m::::me:::::::e            r:::::r          a::::a    a:::::a 
  C:::::CCCCCCCC::::Ca::::a    a:::::a m::::m   m::::m   m::::me::::::::e           r:::::r          a::::a    a:::::a 
   CC:::::::::::::::Ca:::::aaaa::::::a m::::m   m::::m   m::::m e::::::::eeeeeeee   r:::::r          a:::::aaaa::::::a 
     CCC::::::::::::C a::::::::::aa:::am::::m   m::::m   m::::m  ee:::::::::::::e   r:::::r           a::::::::::aa:::a
        CCCCCCCCCCCCC  aaaaaaaaaa  aaaammmmmm   mmmmmm   mmmmmm    eeeeeeeeeeeeee   rrrrrrr            aaaaaaaaaa  aaaa
*/

import { DeviceOrientationControls } from 'three-controls-deviceorientation'

var MIN_NEAR_VIEW = 0.001
var MAX_FAR_VIEW = 100000

//support objects
export default function Camera(options, panorama) {
    var scope = this
    this.isMouseMoving = false
    this.disabled = false
    this.startX = 0
    this.startY = 0
    this.lonVelocity = 0
    this.latVelocity = 0
    this.autoRotateSpeed = options.autoRotateSpeed || 0.3

    // Variables for tracking rotation to a specific position
    this.autoRotate = options.autoRotate
    this.rotationObject = {}

    // save the last lat and long reading so we can calculate deltas later
    this.lastLat = 0
    this.lastLon = 0

    // objects used to get the orientation
    this.deviceOrientatioCamera = null
    this.deviceOrientationControls = null

    this.panorama = panorama

    this.clock = new THREE.Clock()

    this._camera = new THREE.PerspectiveCamera(options.fov, options.width / options.height, MIN_NEAR_VIEW, MAX_FAR_VIEW)
    this._camera.target = new THREE.Vector3()

    //setup raycaster objects
    this.pointerVector = new THREE.Vector3()
    this.raycaster = new THREE.Raycaster()

    this.lon = options.startLon || 0
    this.lat = options.startLat || 0

    this.latDiff = this.lonDiff = 0

    this.maxLat = (options.maxAngle && options.maxAngle.v) || 80
    this.minLat = (options.minAngle && options.minAngle.v) || -90

    this.maxLon = (options.maxAngle && options.maxAngle.h) || 360
    this.minLon = (options.minAngle && options.minAngle.h) || -360

    this.minFov = options.minFov || 40
    this.maxFov = options.maxFov || 120

    this.updateMatrix(options.width, options.height)

    this.lonDeceleration = 0.85
    this.latDeceleration = 0.7

    this.refreshView()

    this.accelerometerControls = options.accelerometerControls
    if (this.accelerometerControls) {
        this.deviceOrientatioCamera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000)
        this.deviceOrientationControls = new DeviceOrientationControls(this.deviceOrientatioCamera)
    }

    return this
}

Camera.prototype = {
    setDisabled: function(disabled) {
        this.setAutoRotate(false)
        this.disabled = disabled
    },
    isDisabled: function() {
        return this.disabled
    },
    refreshView: function() {
        var delta = this.clock.getDelta()

        if (this.isRotating) {
            var timediff = this.rotationObject.duration + this.rotationObject.startTime - new Date().getTime()
            if (timediff <= 0) {
                this.isRotating = false
                this.lat = this.rotationObject.targetLat
                this.lon = this.rotationObject.targetLon
                if (this.rotationObject.callback) {
                    this.rotationObject.callback()
                }
                this.rotationObject = {}
            } else {
                var totalChunks = (new Date().getTime() - this.rotationObject.startTime) / this.rotationObject.duration //seconds ellapsed

                this.lat =
                    (this.rotationObject.targetLat - this.rotationObject.fromLat) * totalChunks +
                    this.rotationObject.fromLat
                this.lon =
                    (this.rotationObject.targetLon - this.rotationObject.fromLon) * totalChunks +
                    this.rotationObject.fromLon
            }
        }
        if (this.isMouseMoving) {
            this.latVelocity = this.latDiff / delta
            this.lonVelocity = this.lonDiff / delta
        } else if (this.lonVelocity || this.latVelocity) {
            this.lon += this.lonVelocity * delta
            this.lat += this.latVelocity * delta

            this.lonVelocity =
                Math[this.lonVelocity > 0 ? 'floor' : 'ceil'](this.lonVelocity * this.lonDeceleration * 100) / 100
            this.latVelocity =
                Math[this.latVelocity > 0 ? 'floor' : 'ceil'](this.latVelocity * this.latDeceleration * 100) / 100
        }

        if (!isFinite(this.latVelocity) || !isFinite(this.lonVelocity)) {
            this.latVelocity = 0
            this.lonVelocity = 0
        }

        if (this.autoRotate) {
            this.lon += this.autoRotateSpeed
        }

        if (this.accelerometerControls && this.deviceOrientatioCamera && !this.isMouseMoving) {
            // update the camera's orientation
            this.deviceOrientationControls.update()

            // calculate the deltas for the orientation
            var deltas = this.calculateOrientationDeltas()

            // add them to our lat / lon
            this.latDiff += isNaN(deltas.lat) ? 0 : deltas.lat
            this.lonDiff += isNaN(deltas.lon) ? 0 : deltas.lon
        } // end if acceleromter controls are enabled

        this.lat += this.latDiff
        this.lon += this.lonDiff

        this.latDiff = this.lonDiff = 0

        this.lat = Math.max(this.minLat, Math.min(this.maxLat, this.lat))
        this.lon = Math.max(this.minLon, Math.min(this.maxLon, this.lon % 360))

        //dont let lon be negative
        if (this.lon < 0) {
            this.lon = 360 + this.lon
        }

        var phi = ((90 - this.lat) * Math.PI) / 180 // phi sets lateral motion (converted to radians)
        var theta = (this.lon * Math.PI) / 180 // theta sets horizontal motion (converted to radians)

        /* Javascript Math functions for circles only take radians */
        this._camera.target.x = Math.sin(phi) * Math.cos(theta)
        this._camera.target.y = Math.cos(phi)
        this._camera.target.z = Math.sin(phi) * Math.sin(theta)

        this._camera.lookAt(this._camera.target)

        this.dirtyZoom = false

        this.refreshCallback({ lon: this.lon, lat: this.lat, fov: this._camera.fov })
    },

    calculateOrientationDeltas: function() {
        // lattitude (vertical) and longitude (yaw) are handled a bit differently.
        // lattitude doesn't need to wrap at the top or bottom, so we can just use the interpolaed values directly,
        // while longitude needs to wrap from 0 to 360 or 360 to 0.

        // lattitude

        // interpolate the lattitude (pitch) from the raw value which is between -PI/2 to PI/2.
        var lat =
            ((this.deviceOrientatioCamera.rotation._x + Math.PI / 2) / Math.PI) * (this.maxLat - this.minLat) +
            this.minLat

        // the deltalat, therefore is easily just the current lat minus the previous late:
        var deltaLat = lat - this.lastLat

        // set for next time
        this.lastLat = lat

        // longitude

        var totalLonRange = this.maxLon - this.minLon

        // let's interpolate the value normally at first (from -PI to PI), but below we will need a bit of extra logic to handle when it wraps
        var lon = -(((this.deviceOrientatioCamera.rotation._y + Math.PI) / (Math.PI * 4)) * totalLonRange) + this.minLon

        // calculate an initial delta:
        var deltaLon = lon - this.lastLon

        // set for next time
        this.lastLon = lon

        // if the delta is greater than 180 in either direction, it most likely wrapped (nobody can move that fast)
        // but we can't compare to 180; when need to compare to 180 in the PanoPlayers units, i.e.: half the total distance of longitude
        var pano180 = totalLonRange / 2
        if (Math.abs(deltaLon) > pano180) {
            // if the jump is negative, we went from a high value to a low value - essentially jumping from ~360 to ~0
            // let's adjust the delta for that jump
            if (deltaLon < 0) {
                // new delta is the sum of two differences: from the old pos to the maximum, and from the minimum to the new pos:
                deltaLon = this.maxLon - this.lastLon + (lon - this.minLon)

                // otherwise, if the jump is positive, we wraped from around ~0 to ~360
            } else if (deltaLon > 0) {
                // new delta is the sum of two differences: from the old pos to the minimum, and from the maximum to the new pos:
                deltaLon = this.lastLon - this.minLon + (this.maxLon - lon)
            }

            // note: inside this if block, deltaLon could never be 0.
        } // end if large jump

        // return our deltas
        return {
            lat: deltaLat,
            lon: deltaLon,
        }
    },

    destroy: function() {
        this.deviceOrientationControls && this.deviceOrientationControls.dispose()
    },

    refreshCallback: function() {},

    needsRefresh: function() {
        return (
            this.isRotating ||
            this.isMouseMoving ||
            +this.latVelocity ||
            +this.lonVelocity ||
            this.dirtyZoom ||
            this.autoRotate ||
            this.accelerometerControls ||
            this.latDiff ||
            this.lonDiff
        )
    },

    updateMatrix: function(width, height) {
        if (width != undefined && height != undefined) {
            this.viewerWidth = width
            this.viewerHeight = height

            //this hook allows us to swap out different tracking functions
            this.setPosition = this.setPositionExact
        }

        this._camera.aspect = this.viewerWidth / this.viewerHeight
        this._camera.updateProjectionMatrix()
    },

    zoom: function(wheelDelta) {
        this._camera.fov -= wheelDelta
        this.refreshZoom()
    },

    refreshZoom: function() {
        this.dirtyZoom = true
        this._camera.fov = Math.min(this.maxFov, Math.max(this.minFov, this._camera.fov))
        this._camera.updateProjectionMatrix()
    },

    getCamera: function() {
        return this._camera
    },

    setAutoRotate: function(onOff, autoRotateSpeed) {
        this.autoRotate = !this.isDisabled() && onOff
        if (autoRotateSpeed) {
            this.autoRotateSpeed = autoRotateSpeed
        }
    },

    setMouseMoving: function(moving) {
        this.isMouseMoving = moving
    },

    setStart: function(x, y) {
        this.startPoint = this.getPointFromMouse(x, y)

        this.startX = x
        this.startY = y
        this.startTime = this.clock.getElapsedTime()
    },

    getPosition: function() {
        return {
            lat: this.lat,
            lon: this.lon,
            fov: this._camera.fov,
        }
    },

    /*
		this function returns the shortest distance coord from current to target
		this will prevent the camera from rotating more than 180 degrees
		 */
    getShortestLatLon: function(lat, lon) {
        var f = function(curr, next) {
            var coords = [next - 360, next, next + 360]
            var distances = coords.map(function(c) {
                return Math.abs(curr - c)
            })
            return coords[distances.indexOf(Math.min.apply(null, distances))]
        }

        return {
            lat: f(this.lat, lat),
            lon: f(this.lon, lon),
        }
    },

    setAbsolutePosition: function(position, options) {
        var lat = position.lat == undefined ? this.lat : position.lat,
            lon = position.lon == undefined ? this.lon : position.lon,
            fov = position.fov == undefined ? this.fov : position.fov

        if (options.duration || options.speed) {
            var shortCoord = this.getShortestLatLon(lat, lon)

            if (!options.duration && options.speed) {
                var totalDegrees = Math.sqrt(
                    Math.pow(this.lat - shortCoord.lat, 2) + Math.pow(this.lon - shortCoord.lon, 2)
                )

                options.duration = (totalDegrees / options.speed) * 1000
            }

            // Force the view to refresh first to update the clock
            this.refreshView()
            this.isRotating = true
            this.rotationObject.fromLon = this.lon
            this.rotationObject.fromLat = this.lat
            this.rotationObject.targetLat = shortCoord.lat
            this.rotationObject.targetLon = shortCoord.lon
            this.rotationObject.startTime = new Date().getTime()
            this.rotationObject.duration = options.duration
            this.rotationObject.callback = options.callback

            this.setAutoRotate(false)
        } else {
            this.lat = lat
            this.lon = lon
            this.fov = fov
        }
        this.refreshView()
        this.refreshZoom()
    },

    setPositionExact: function(x, y) {
        if (this.isMouseMoving && !this.processingMove && !this.latDiff && !this.lonDiff) {
            this.processingMove = true

            var point = this.getPointFromMouse(x, y),
                radius = this.viewerWidth * 4,
                spLat = Math.asin(this.startPoint.y / radius),
                pLat = Math.asin(point.y / radius),
                latDiff = ((spLat - pLat) * 180) / Math.PI,
                spLon = Math.atan(this.startPoint.z / this.startPoint.x),
                pLon = Math.atan(point.z / point.x),
                lonDiff

            if ((point.x < 0 && this.startPoint.x > 0) || (point.x > 0 && this.startPoint.x < 0)) {
                if (pLon > 0 && spLon < 0) {
                    lonDiff = Math.PI + spLon - pLon
                } else if (pLon < 0 && spLon > 0) {
                    lonDiff = Math.PI - spLon + pLon
                } else {
                    lonDiff = spLon - pLon
                    // debugger;
                }

                //adjust for direction
                if ((point.x < 0 && this.lon < 180) || (point.x > 0 && this.lon > 180)) {
                    lonDiff *= -1
                }
            } else {
                lonDiff = spLon - pLon
            }

            lonDiff *= 180 / Math.PI

            this.latDiff += latDiff
            this.lonDiff += lonDiff

            this.processingMove = false
        }
    },

    getPointFromMouse: function(x, y) {
        var rect = this.panorama.element.getBoundingClientRect()

        x = (x - rect.left) / rect.width
        y = (y - rect.top) / rect.height

        this.pointerVector.set(x * 2 - 1, -y * 2 + 1, 0.5)
        return this.getPointerVectorIntersect()
    },

    getPointerVectorIntersect: function() {
        this.pointerVector.unproject(this.getCamera())

        this.raycaster.set(this.getCamera().position, this.pointerVector.normalize())

        var intersects = this.raycaster.intersectObject(this.panorama.intersectionMesh)

        return intersects.length ? intersects[0].point : null
    },
}
